<div appTheme *ngIf="!isOnline" class="modal-box scrolling">
    <div class="is-online-message-box-container">
        <div class="message-box-icon-container">
            <i class="fa fa-5x fa-exclamation-triangle" aria-hidden="true"></i>
        </div>
        <div class="is-online-message-box-text">
            <span>There seems to be a problem with your internet connection or SMRTScape server is down. Please check your internet connection and retry or wait until a connection has been established.</span>
        </div>
    </div>
</div>
